<div class="footer ns">
  <div class="footer-left">
    <z-version></z-version>
  </div>
  <div class="footer-right">
    <z-copyright></z-copyright>
  </div>
</div>

<z-about></z-about>
